import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
`;

export const Arrow = styled.button`
	width: 40px;
	height: 100%;
	border: none;
	background: transparent;
	font-size: 22px;
	cursor: pointer;
	flex-shrink: 0;
`;

export const DatesViewport = styled.div`
	width: 100%;
	overflow-x: auto;
	overflow-y: hidden;
	scroll-behavior: smooth;

	scrollbar-width: none;
	&::-webkit-scrollbar {
		display: none;
	}
`;

export const DatesWrapper = styled.div`
	display: flex;
	width: fit-content;
`;

export const DateCard = styled.div<{
	active?: boolean;
	isFirst?: boolean;
	isLast?: boolean;
	isSingle?: boolean;
}>`
	flex: 0 0 120px;
	max-width: 120px;

	padding: 14px 10px;
	text-align: center;
	cursor: pointer;

	background: ${({ active }) => (active ? '#0d6efd' : '#fff')};
	color: ${({ active }) => (active ? '#fff' : '#333')};

	border-right: 1px solid #e5e5e5;

	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 4px;

	border-radius: ${({ isSingle, isFirst, isLast }) => {
		if (isSingle) return '6px';
		if (isFirst) return '6px 0 0 6px';
		if (isLast) return '0 6px 6px 0';
		return '0';
	}};
`;

export const Day = styled.span`
	font-size: 12px;
	text-transform: capitalize;
`;

export const DateText = styled.span`
	font-size: 20px;
	font-weight: 700;
`;

export const Hour = styled.span`
	font-size: 16px;
	font-weight: 600;
`;
